import React from 'react';
import { FormState } from '../../types';
import { Textarea } from '../ui/Textarea';
interface Props {
  state: FormState;
  onChange: (field: keyof FormState, value: any) => void;
}
export function Notes({
  state,
  onChange
}: Props) {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-213">
      <div className="col-span-1 md:col-span-2 lg:col-span-4" data-id="element-214">
        <Textarea label="Roadmap" helperText="Outline the general strategy and timeline for this loan." value={state.roadmapNotes} onChange={e => onChange('roadmapNotes', e.target.value)} className="min-h-[120px]" data-id="element-215" />
      </div>
      <div className="col-span-1 md:col-span-2 lg:col-span-4" data-id="element-216">
        <Textarea label="Appraisal Notes" helperText="Any specific details regarding the property appraisal or waivers." value={state.appraisalNotes} onChange={e => onChange('appraisalNotes', e.target.value)} data-id="element-217" />
      </div>
      <div className="col-span-1 md:col-span-2 lg:col-span-4" data-id="element-218">
        <Textarea label="Income Notes" helperText="Details about borrower income, employment verification, or tax returns." value={state.incomeNotes} onChange={e => onChange('incomeNotes', e.target.value)} data-id="element-219" />
      </div>
      <div className="col-span-1 md:col-span-2 lg:col-span-4" data-id="element-220">
        <Textarea label="Asset Notes" helperText="Information regarding funds to close, bank statements, or asset depletion." value={state.assetNotes} onChange={e => onChange('assetNotes', e.target.value)} data-id="element-221" />
      </div>
      <div className="col-span-1 md:col-span-2 lg:col-span-4" data-id="element-222">
        <Textarea label="Credit Notes" helperText="Notes on credit history, liabilities, or required payoffs." value={state.creditNotes} onChange={e => onChange('creditNotes', e.target.value)} data-id="element-223" />
      </div>
    </div>;
}